// extracted by mini-css-extract-plugin
export default {"buttonCircle":"ButtonCollapse_buttonCircle__KG438","active":"ButtonCollapse_active__cL1K9","inactive":"ButtonCollapse_inactive__1Wuk3"};